export function mark(name: string) {
	if (typeof performance.mark === 'function') {
		performance.mark('advert - ' + name);
	}
}
